const action = {
    general: 'При выполнении действия произошла ошибка. Повторите попытку позже.',
    sign_in_identifier_changed: 'Действие не может изменить идентификатор входа, использованный для этой проверки.',
};
export default Object.freeze(action);
